// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__t05_V","content":"ManualTimeModal_content__2ygws"};